import { ProductType } from '@/types';

export const getPrintArea = (productType: ProductType, printAreaId: string) =>
  productType.printAreas.find(({ id }) => id === printAreaId);
